export default __webpack_public_path__ + "static/media/bg-contact-us.cc94e4d1.png";